import { GROUPS } from './GROUPS';
import { ROLES_GROUPS } from './ROLES_GROUPS';
import { ROLES } from './ROLES';

export enum OrderActionCrmTask {
    OC = 'OC',
    PRODUCCION = 'Producción',
    ENTREGA = 'Entrega',
    FACTURACION = 'Facturación',
    COBRANZA = 'Cobranza'
}

export interface OrderAction {
    id: number;
    name: string;
    button: string | null;
    /** Permite que el ejecutivo salte este paso del flujo. */
    skipStepButton: boolean;
    enabledMessage: string;
    disbledMessage: string;
    defaultPermissions: string[];
    defaultNotifications: string[];
    crmTask?: OrderActionCrmTask;
}

export const PREMIUM_ORDER_ACTIONS: OrderAction[] = [
    {
        id: 1,
        name: 'Solicitud de muestras',
        button: 'Definir muestras',
        skipStepButton: true,
        enabledMessage:
            'Cotización autorizada, indica para que productos requieres muestras',
        disbledMessage:
            'Cotización autorizada, definición de muestras pendiente',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.MANAGEMENT,
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 2,
        name: 'Cargar acuses de entrega',
        button: 'Cargar evidencias de entrega',
        skipStepButton: false,
        enabledMessage: 'Debes de subir los documentos de entregas y guías',
        disbledMessage:
            'Orden y muestras aprobadas, en espera de entrega por proveedores',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ],
        crmTask: OrderActionCrmTask.ENTREGA
    },
    {
        id: 3,
        name: 'GR y fecha de pago',
        button: 'No hay cambios 1',
        skipStepButton: false,
        enabledMessage: 'Producto entregado, carga las tablas de GR',
        disbledMessage: 'Producto entregado, en espera de código GR',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 4,
        name: 'Revisar muestras',
        button: 'Revisar muestras',
        skipStepButton: true,
        enabledMessage:
            'Muestras cargadas por los proveedores, para avanzar con el flujo debes aprobar las muestras',
        disbledMessage:
            'En espera de aprobación de muestras por el contratante',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 5,
        name: 'Carga de OC Coupa',
        button: 'Cargar OC Coupa',
        skipStepButton: false,
        enabledMessage:
            'Cotización autorizada y enviada, cargue la orden de compra de Coupa',
        disbledMessage:
            'Cotización autorizada y enviada, en espera de OC Coupa',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 6,
        name: 'Solicitud factoraje',
        button: 'Solicitar factoraje',
        skipStepButton: false,
        enabledMessage:
            'Proveedores con fecha de pago, en espera de orden de pago',
        disbledMessage:
            'Proveedores con fecha de pago, en espera de orden de pago',
        defaultPermissions: [...ROLES_GROUPS.PROVIDER_GROUP],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS, GROUPS.PROVIDER]
    },
    {
        id: 7,
        name: 'Checkout a Coupa',
        button: 'Checkout a Coupa',
        skipStepButton: true,
        enabledMessage: 'Pedido cotizado, puedes hacer tu checkout a Coupa',
        disbledMessage: 'Pedido cotizado, en espera de checkout a Coupa',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR,
            GROUPS.COUPA
        ]
    },
    {
        id: 8,
        name: 'Validar facturas',
        button: 'Validar Facturas',
        skipStepButton: false,
        enabledMessage: 'Valida las facturas del proyecto en el CRM',
        disbledMessage: 'En espera de validación de facturas',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION
        ],
        crmTask: OrderActionCrmTask.FACTURACION
    },
    {
        id: 9,
        name: 'Subir GR',
        button: 'Subir GR',
        skipStepButton: false,
        enabledMessage: 'Producto entregado, carga las tablas de GR',
        disbledMessage: 'Producto entregado, en espera de código GR',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 10,
        name: 'Validar carga de acuses',
        button: 'He cargado todos los acuses',
        skipStepButton: false,
        enabledMessage:
            'Debes validar que has cargado todos los acuses de entrega',
        disbledMessage:
            'Orden y muestras aprobadas, en espera de entrega por proveedores',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 11,
        name: 'Autorización por compras',
        button: 'Autorizar cotización',
        skipStepButton: true,
        enabledMessage: 'Cotización en espera de autorización por compras',
        disbledMessage: 'Cotización en espera de autorización por compras',
        defaultPermissions: [ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 12,
        name: 'Validar Entrega',
        button: 'Validar entrega',
        skipStepButton: false,
        enabledMessage: 'Valida que se ha concretado la entrega de productos',
        disbledMessage: 'En espera de que se valide la entrega de productos',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 13,
        name: 'Completar orden',
        button: 'Completar',
        skipStepButton: false,
        enabledMessage:
            'Para completar la orden sube los comprobantes de pago en el CRM',
        disbledMessage: 'En espera de que se suban los comprobantes de pago',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.OPERATIVO, GROUPS.AGENTS],
        crmTask: OrderActionCrmTask.COBRANZA
    },
    {
        id: 14,
        name: 'Aprobación Administración',
        button: 'Notificar versión final',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 15,
        name: 'Subir factura',
        button: 'Subir Factura',
        skipStepButton: false,
        enabledMessage: 'Por favor sube las facturas en el CRM',
        disbledMessage: 'En espera de facturas',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION
        ]
    },
    {
        id: 16,
        name: 'Proceso finalizado',
        button: null,
        skipStepButton: false,
        enabledMessage: 'Proceso finalizado',
        disbledMessage: 'Proceso finalizado',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.MANAGEMENT,
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 17,
        name: 'Cambios proveedores precotización',
        button: 'No hay cambios',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 18,
        name: 'Confirmación por Marketing',
        button: 'Confirmar precotización',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 19,
        name: 'Carga de muestras por proveedores',
        button: 'Subir muestras',
        skipStepButton: false,
        enabledMessage:
            'Si se te solicitaron muestras de productos, debes de subir los documentos de aprobación de muestras',
        disbledMessage: 'Espere a que todos los proveedores suban sus muestras',
        defaultPermissions: [
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.PROVIDER,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 20,
        name: 'Solicitar calidad',
        button: 'No hay cambios 1',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 21,
        name: 'Llenado de calidad',
        button: 'Subir documentos calidad en Sharepoint',
        skipStepButton: false,
        enabledMessage:
            'Una vez llenados los formatos de calidad deben enviarse al departamento de calidad',
        disbledMessage: 'Proceso de calidad en ejecución',
        defaultPermissions: [
            ROLES.CALIDAD,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.ADMINISTRATOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 22,
        name: 'Validación calidad compras',
        button: 'Revisar documentos calidad',
        skipStepButton: false,
        enabledMessage: 'Valida la información de calidad de los productos',
        disbledMessage: 'El usuario de calidad debe validar la información',
        defaultPermissions: [ROLES.CALIDAD],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 23,
        name: 'Carga archivo calidad',
        button: 'Subir documentos calidad',
        skipStepButton: false,
        enabledMessage:
            'Debes enviar los documentos de calidad aprobados y firmados a Pico y subirlos al portal',
        disbledMessage: 'En espera de que se complete proceso de calidad',
        defaultPermissions: [
            ROLES.CALIDAD,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.ADMINISTRATOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 24,
        name: 'Autorización por compras 2',
        button: 'Autorizar cotización',
        skipStepButton: true,
        enabledMessage: 'Cotización en espera de autorización por compras',
        disbledMessage: 'Cotización en espera de autorización por compras',
        defaultPermissions: [ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 25,
        name: 'Evaluación de productos',
        button: 'Evaluar',
        skipStepButton: true,
        enabledMessage:
            'Pedido entregado, por favor ayúdanos a evaluar tu experiencia de compra',
        disbledMessage: 'En espera de evaluación de compra',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 26,
        name: 'Checkout Conekta',
        button: 'Proceder a pago',
        skipStepButton: true,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 27,
        name: 'Carga OC Conekta',
        button: 'Cargar OC Conekta',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 28,
        name: 'Realizar pago con Clip',
        button: 'Proceder a pago',
        skipStepButton: true,
        enabledMessage:
            'Al presionar "Proceder a pago" serás redirigido. No cierres la página hasta completar el pago.',
        disbledMessage: 'En espera de pago con Clip (TDC o TDD)',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 29,
        name: 'Validar pago Clip',
        button: 'Validar pago en Clip',
        skipStepButton: false,
        enabledMessage:
            'Pedido pagado, verifica que el pago se refleje en Clip (TDC o TDD) antes de validarlo',
        disbledMessage:
            'Pago realizado. En proceso de validación. Si requieres factura, sube tu constancia de situación fiscal.',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 30,
        name: 'Carga OC',
        button: 'Cargar orden de compra',
        skipStepButton: false,
        enabledMessage:
            'Cotización autorizada, cargue la orden de compra o evidencia de solicitud del proyecto',
        disbledMessage: 'Cotización autorizada y enviada, en espera de OC',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 31,
        name: 'Carga comprobante transferencia bancaria',
        button: 'Carga comprobante transferencia bancaria',
        skipStepButton: true,
        enabledMessage:
            'Por favor cargue el comprobante de transferencia bancaria a la CLABE 1121 8000 0035 056332, Beneficiario: SOURCE DATA PURCHASING SA DE CV',
        disbledMessage:
            'Cotización autorizada y enviada, en espera de comprobante de transferencia bancaria',
        defaultPermissions: [
            ...ROLES_GROUPS.MKT_GROUP,
            ...ROLES_GROUPS.SD_GROUP
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 32,
        name: 'Validar comprobante transferencia bancaria',
        button: 'Validar comprobante transferencia bancaria',
        skipStepButton: false,
        enabledMessage:
            'Por favor valide el comprobante para iniciar el flujo de logística',
        disbledMessage:
            'En espera de validación del comprobante por parte de Pico',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 33,
        name: 'Realizar pago con EtPay',
        button: 'Proceder a pago',
        skipStepButton: true,
        enabledMessage:
            'Al presionar "Proceder a pago" serás redirigido. No cierres la página hasta completar el pago.',
        disbledMessage: 'En espera de pago con Etpay (Transferencia)',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 34,
        name: 'Validar pago EtPay',
        button: 'Validar pago EtPay',
        skipStepButton: false,
        enabledMessage:
            'Pedido pagado, verifica que el pago se refleje en EtPay (Transferencia) antes de validarlo',
        disbledMessage:
            'Pago realizado. En proceso de validación. Si requieres factura, sube tu constancia de situación fiscal.',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 35,
        name: 'Realizar pago con Stripe',
        button: 'Proceder a pago',
        skipStepButton: true,
        enabledMessage:
            'Al presionar "Proceder a pago" serás redirigido. No cierres la página hasta completar el pago.',
        disbledMessage: 'En espera de pago con Stripe (Tarjeta)',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 36,
        name: 'Validar pago Stripe',
        button: 'Validar pago Stripe',
        skipStepButton: false,
        enabledMessage:
            'Pedido pagado, verifica que el pago se refleje en Stripe antes de validarlo',
        disbledMessage:
            'Pago realizado. En proceso de validación. Si requieres factura, sube tu constancia de situación fiscal.',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    }
];

/**
 * IDs de subproceso (`OrderSubprocessStructure.action`) en los que la UI del pedido
 * premium muestra controles de facturación en la barra de acciones (factura, CSF,
 * datos de transferencia, etc.).
 *
 * No incluye **30** (Carga OC): ese paso no activa ese bloque de facturación en esa barra.
 * Tampoco incluye **35** / **36** (Stripe); si deben comportarse como Clip/EtPay, añadir sus ids aquí.
 *
 * @see PREMIUM_ORDER_ACTIONS — entradas con id 28, 29, 31, 32, 33, 34 (y 30 como contraste excluido)
 */
export const PREMIUM_ORDER_BILLING_UI_ACTION_IDS: ReadonlyArray<number> = [
    28,
    29,
    31,
    32,
    33,
    34
];

/** Subproceso "Completar orden" (comprobantes de pago finales). */
export const PREMIUM_ORDER_ACTION_COMPLETAR_ORDEN_ID = 13;

/** Subproceso "Proceso finalizado" — sin reasignar ni eliminar desde la barra de acciones. */
export const PREMIUM_ORDER_ACTION_PROCESO_FINALIZADO_ID = 16;
